import moment from 'moment';

import { capitalizeFirstLetter } from '../../helpers';
import { ActionRequiredItemEnum, ENTITY_PREFIX } from '../../constants';

import type { ActionRequiredItem } from './components/ActionRequiredCard';
import type { Moment } from 'moment';

export function getClientLabelForActionRequiredItem(
  item: ActionRequiredItem,
  type: ActionRequiredItemEnum,
) {
  if (type === ActionRequiredItemEnum.GroupParent) {
    const clientLen = 'clients' in item ? (item.clients?.length ?? 0) : 0;
    return `${
      clientLen > 0 ? `${clientLen} ${clientLen > 1 ? 'Families' : 'Family'}` : 'No clients added'
    } `;
  }
  const client = 'client' in item ? item.client : undefined;
  return `${client?.first_name} ${client?.last_name}`;
}

export function getActionRequiredItemTimeLabel(
  date: string | Date | Moment | null,
  type: ActionRequiredItemEnum,
) {
  if (!date) {
    if (type === ActionRequiredItemEnum.TreatmentPlan) {
      return 'N/A';
    }
    return '';
  } else {
    return `${capitalizeFirstLetter(moment(date).fromNow())}`;
  }
}

export function getCSNTimeRequiredTooltipLabel(seconds: number) {
  const hours = Math.floor(seconds / 3600); // Calculate whole hours
  const remainingSeconds = seconds % 3600; // Remaining seconds after hours
  const minutes = Math.ceil(remainingSeconds / 60); // Convert remaining seconds to minutes

  return `${hours > 0 ? `${hours} ${hours === 1 ? 'hour' : 'hours'}` : ''}${
    minutes > 0 ? ` ${minutes} ${minutes === 1 ? 'minute' : 'minutes'}` : ''
  } of 97155 needed to meet the CSN requirement.`;
}

export function getPrefixForActionRequiredCardId(type: ActionRequiredItemEnum) {
  switch (type) {
    case ActionRequiredItemEnum.Assessment:
    case ActionRequiredItemEnum.Assessment2:
      return ENTITY_PREFIX.ClientAssessmentNote;
    case ActionRequiredItemEnum.Client:
      return ENTITY_PREFIX.ClientSupervisionNotes;
    case ActionRequiredItemEnum.Bt:
      return ENTITY_PREFIX.BTSupervisionNotes;
    case ActionRequiredItemEnum.GroupParent:
      return ENTITY_PREFIX.GroupSupervisionNotes;
    case ActionRequiredItemEnum.Parent:
      return ENTITY_PREFIX.ParentSupervisionNotes;
    case ActionRequiredItemEnum.TreatmentPlan:
      return ENTITY_PREFIX.TreatmentPlan;
  }
}
